module.exports = "<meta name=\"keywords\" content=\"{{seoKeyword}}\">"